export enum DateFormat {
  TodayTime,
  ShortDate,
  LongDate,
  ShortDateTime,
  LongDateTime,
  Time
}

export enum RecurrenceType {
  None = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
  BiMonthly = 5,
  TriMonthly = 6,
  HalfYearly = 7
}

export class CalendarShortKey {
  constructor(public key: string, public title: string, date?: (now: Date) => void, to?: (now: Date) => void) {
    this.setter = date;
    this.toSetter = to;
  }

  private setter?: (now: Date) => void;
  private toSetter?: (now: Date) => void;
  get date() {
    if (!this.setter) return null;
    var date = new Date();
    this.setter(date);
    return date;
  }
  get to() {
    var date = new Date();
    if (this.toSetter) { this.toSetter(date); }
    return date;
  }
}

export class DayTimeShortKey {
  constructor(public key: string, public title: string, public hour: number, public minute = 0) { }
}

export class DateConstants {
  static get minDate() { return new Date(Date.UTC(623, 0)); }
  static get maxDate() { return new Date(Date.UTC(2999, 11)); }
  static oneMinute = 1000 * 60;
  static oneHour = 1000 * 60 * 60;
  static oneDay = 1000 * 60 * 60 * 24;
  static oneWeek = 1000 * 60 * 60 * 24 * 7;
  static oneMonth = 1000 * 60 * 60 * 24 * 30;
  static oneYear = 1000 * 60 * 60 * 24 * 30 * 12;

  static worldDays = {
    // '6-5': ['روز جهانی محیط زیست']
  };
  static persianDays = {
    // '3-6': ['خرداد روز', 'جشن خردادگان']
  };
  static persianHolidays: { [key: string]: string[] } = {
    '1-1': ['جشن نوروز'],
    '1-2': ['جشن نوروز'],
    '1-3': ['جشن نوروز'],
    '1-4': ['جشن نوروز'],
    '1-12': ['روز جمهوری اسلامی ایران'],
    '1-13': ['جشن سیزده به در'],
    '3-14': ['رحلت امام خمینی'],
    '3-15': ['قیام 15 خرداد'],
    '11-22': ['پیروزی انقلاب اسلامی'],
    '12-29': ['روز ملی شدن صنعت نفت ایران'],
  };
  static islamicDays: { [key: string]: string[] } = {
    // '8-19': ['ضربت خوردن حضرت علی']
  };
  static islamicHolidays: { [key: string]: string[] } = {
    '1-9': ['تاسوعای حسینی'],
    '1-10': ['عاشورای حسینی'],
    '2-20': ['اربعین حسینی'],
    '2-28': ['رحلت رسول اکرم', 'شهادت امام حسن مجتبی'],
    '2-29': ['شهادت امام رضا'],
    '3-8': ['شهادت امام حسن عسکری'],
    '3-17': ['میلاد رسول اکرم', 'میلاد امام جعفر صادق'],
    '6-3': ['شهادت حضرت فاطمه'],
    '7-13': ['ولادت امام علی', 'روز پدر'],
    '7-27': ['مبعث رسول اکرم'],
    '8-15': ['ولادت حضرت مهدی'],
    '9-21': ['شهادت حضرت علی'],
    '10-1': ['عید سعید فطر'],
    '10-2': ['عید سعید فطر'],
    '10-25': ['شهادت امام جعفر صادق'],
    '12-10': ['عید سعید قربان'],
    '12-18': ['عید سعید غدیر خم']
  };

  static persianIslamicHolidays: { [key: number]: { [key: string]: string[] } } = {
    1397: {
      '1-11': ['ولادت امام علی', 'روز پدر'],
      '1-25': ['مبعث رسول اکرم'],
      '2-12': ['ولادت حضرت مهدی'],
      '3-16': ['شهادت حضرت علی'],
      '3-25': ['عید سعید فطر'],
      '3-26': ['عید سعید فطر'],
      '4-18': ['شهادت امام جعفر صادق'],
      '5-31': ['عید سعید قربان'],
      '6-8': ['عید سعید غدیر خم'],
      '6-28': ['تاسوعای حسینی'],
      '6-29': ['عاشورای حسینی'],
      '8-8': ['اربعین حسینی'],
      '8-16': ['رحلت رسول اکرم', 'شهادت امام حسن مجتبی'],
      '8-17': ['شهادت امام رضا'],
      '8-25': ['شهادت امام حسن عسکری'],
      '9-4': ['میلاد رسول اکرم', 'میلاد امام جعفر صادق'],
      '11-20': ['شهادت حضرت فاطمه'],
      '12-29': ['ولادت امام علی', 'روز پدر'],
    },
    1398: {
      '1-14': ['مبعث رسول اکرم'],
      '2-1': ['ولادت حضرت مهدی'],
      '3-5': ['شهادت حضرت علی'],
      '3-15': ['عید سعید فطر'],
      '3-16': ['عید سعید فطر'],
      '4-8': ['شهادت امام جعفر صادق'],
      '5-21': ['عید سعید قربان'],
      '5-29': ['عید سعید غدیر خم'],
      '6-18': ['تاسوعای حسینی'],
      '6-19': ['عاشورای حسینی'],
      '7-27': ['اربعین حسینی'],
      '8-5': ['رحلت رسول اکرم', 'شهادت امام حسن مجتبی'],
      '8-7': ['شهادت امام رضا'],
      '8-15': ['شهادت امام حسن عسکری'],
      '8-24': ['میلاد رسول اکرم', 'میلاد امام جعفر صادق'],
      '11-9': ['شهادت حضرت فاطمه'],
      '12-18': ['ولادت امام علی', 'روز پدر'],
    },
    1399: {

      '1-3': ['مبعث رسول اکرم'],
      '1-20': ['ولادت حضرت مهدی'],
      '2-25': ['شهادت حضرت علی'],
      '3-4': ['عید سعید فطر'],
      '3-5': ['عید سعید فطر'],
      '3-28': ['شهادت امام جعفر صادق'],
      '5-10': ['عید سعید قربان'],
      '5-18': ['عید سعید غدیر خم'],
      '6-7': ['تاسوعای حسینی'],
      '6-8': ['عاشورای حسینی'],
      '7-16': ['اربعین حسینی'],
      '7-24': ['رحلت رسول اکرم', 'شهادت امام حسن مجتبی'],
      '7-26': ['شهادت امام رضا'],
      '8-4': ['شهادت امام حسن عسکری'],
      '8-13': ['میلاد رسول اکرم', 'میلاد امام جعفر صادق'],
      '9-27': ['شهادت حضرت فاطمه'],
      '12-7': ['ولادت امام علی', 'روز پدر'],
      '12-21': ['مبعث رسول اکرم'],
    },
    1400: {
      '1-8': ['ولادت حضرت مهدی'],
      '2-13': ['شهادت حضرت علی'],
      '2-23': ['عید سعید فطر'],
      '2-24': ['عید سعید فطر'],
      '3-16': ['شهادت امام جعفر صادق'],
      '4-29': ['عید سعید قربان'],
      '5-6': ['عید سعید غدیر خم'],
      '5-26': ['تاسوعای حسینی'],
      '5-27': ['عاشورای حسینی'],
      '7-5': ['اربعین حسینی'],
      '7-13': ['رحلت رسول اکرم', 'شهادت امام حسن مجتبی'],
      '7-14': ['شهادت امام رضا'],
      '7-22': ['شهادت امام حسن عسکری'],
      '8-1': ['میلاد رسول اکرم', 'میلاد امام جعفر صادق'],
      '9-16': ['شهادت حضرت فاطمه'],
      '11-25': ['ولادت امام علی', 'روز پدر'],
      '12-9': ['مبعث رسول اکرم'],
      '12-27': ['ولادت حضرت مهدی'],
    },
  };
}

export class HijriDate {
  constructor(public year: number, public month: number, public day: number) { }
}

export class PersianDate {

  isEmpty = true;

  constructor(year: number | undefined, month: number | undefined, day: number | undefined);
  constructor(year: number | undefined, month: number | undefined, day: number | undefined, hour: number | undefined, minute: number | undefined);
  constructor(georgianDate: Date);
  constructor(persianDate: string);
  constructor();

  constructor(year?: number | Date | string, month: number = 1, day: number = 1, hour: number = 0, minute: number = 0) {

    if (year === '') return;
    this.isEmpty = false;
    if (year == undefined) { year = new Date(); }
    if (typeof year == 'string' && (<any>new Date(<string>year)) != 'Invalid Date') { year = new Date(<string>year); }

    if (year instanceof Date) {
      const j = PersianDate.gregorianToJulianDay(year) + (Math.floor(0 + 60 * (0 + 60 * 0) + 0.5) / 86400.0);
      const result = PersianDate.julianDayToPersian(j);
      this._hour = result._hour = year.getHours();
      this._minute = result._minute = year.getMinutes();
      return result;
    } else if (typeof year == 'string') {
      try {
        const dArray = PersianDate.splitDateString(<string>year);
        return new PersianDate(parseInt(dArray[0], 10), parseInt(dArray[1], 10), parseInt(dArray[2], 10));
      } catch (e) { }
      return new PersianDate();
    } else {
      this.year = <number>year;
      this.month = month;
      this.day = day;

      this.hour = hour < 0 ? 0 : hour > 23 ? 23 : hour;
      this.minute = minute < 0 ? 0 : minute > 59 ? 59 : minute;
    }
  }

  get year() { return this._year && this._year >= 0 ? +this._year : 0; }
  get month() { return this._month && this._month >= 0 ? +this._month : 0; }
  get day() { return this._day && this._day >= 0 ? +this._day : 0; }
  get hour() { return this._hour && this._hour >= 0 ? +this._hour : 0; }
  get minute() { return this._minute && this._minute >= 0 ? +this._minute : 0; }
  get hasTime() { return this._hour && this._hour >= 0 || this._minute && this._minute >= 0; }
  get time() { return this.hasTime ? `${('0' + this.hour).slice(-2)}:${('0' + this.minute).slice(-2)}` : ''; }
  set time(time: string) {
    const t = time ? time.split(':') : ['0', '0'];
    this.hour = parseInt(t[0]);
    this.minute = parseInt(t[1]);
  }
  get week() {
    const first = new PersianDate(this.year, this.month, 1);
    const days = Math.floor((this.toGregorian().getTime() - first.toGregorian().getTime()) / (1000 * 60 * 60 * 24));
    return Math.floor(days / 7) + (this.weekday < first.weekday ? 1 : 0) + 1;
  }

  set year(value: number) {
    if (this._year === value) return;
    this._year = value;
    this.month = this.month;
    this._onchanged();
  }
  fixYear() {
    if (this.year! < 10) this.year! += 1400;
    if (this.year! < 100) this.year! += 1300;
  }
  set month(value: number) {
    if (this._month === value) return;
    this._month = value < 1 ? 1 : value > 12 ? 12 : value;
    this.day = this.day;
    this._onchanged();
  }
  set day(value: number) {
    if (value == undefined) return;
    if (value < 1) { value = 1; }
    if (value > 31) { value = 31; }
    if (value > 29 && this.month && this.month > 6) {
      value = this.month == 12 && !this.isLeap ? 29 : 30;
    }
    if (this._day === value) return;

    this._day = +value;
    delete this._weekday;
    this._onchanged();
  }
  set hour(value: number) {
    if (this._hour === value) return;
    if (value && value < 0) { value = value % 24 + 24; }
    this._hour = (value || 0) % 24;
    this._onchanged();
  }
  set minute(value: number) {
    if (this._minute === value) return;
    if (value && value < 0) { value = value % 60 + 60; }
    this._minute = (value || 0) % 60;
    this._onchanged();
  }
  get weekday() {
    if (!this._weekday) {
      this._weekday = (PersianDate.julianToWeekday(PersianDate.persianToJulianDay(this)) + 1) % 7;
    }
    return this._weekday;
  }

  get isLeap() { return ((((((this.year - ((this.year > 0) ? 474 : 473)) % 2820) + 474) + 38) * 682) % 2816) < 682; }
  get monthDays() { return (this.month < 7 ? 31 : (this.month < 12 || this.isLeap ? 30 : 29)); }


  static WeekdaysShort = new Array('ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج');
  static Weekdays = new Array('شنبه', 'یک‌شنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه');
  static MonthNames = new Array('', 'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند');
  static MonthNameList = new Array('فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند');
  static OrdinalNumbers = new Array('', 'اول', 'دوم', 'سوم', 'چهارم', 'پنجم', 'ششم');
  static RecurrenceNames = [
    { type: RecurrenceType.None, title: 'فقط یک بار' },
    { type: RecurrenceType.Daily, title: 'روزانه' },
    { type: RecurrenceType.Weekly, title: 'هفتگی' },
    { type: RecurrenceType.Monthly, title: 'ماهانه' },
    { type: RecurrenceType.BiMonthly, title: 'هر دو ماه' },
    { type: RecurrenceType.TriMonthly, title: 'هر سه ماه' },
    { type: RecurrenceType.HalfYearly, title: 'هر شش ماه' },
    { type: RecurrenceType.Yearly, title: 'سالانه' },
  ];

  static DateTimeShortkeys: { [key: string]: CalendarShortKey } = {
    notset: new CalendarShortKey('notset', 'بدون زمان'),
    last7days: new CalendarShortKey('last7days', 'هفته قبل همین روز', (now: Date) => { now.setTime(now.getTime() - 7 * DateConstants.oneDay); now.setHours(8, 0, 0, 0); }),
    last2days: new CalendarShortKey('last2days', 'پریروز', (now: Date) => { now.setTime(now.getTime() - 2 * DateConstants.oneDay); now.setHours(8, 0, 0, 0); }),
    yesterday: new CalendarShortKey('yesterday', 'دیروز', (now: Date) => { now.setTime(now.getTime() - 1 * DateConstants.oneDay); now.setHours(8, 0, 0, 0); }),
    today: new CalendarShortKey('today', 'امروز', () => { }),
    morning: new CalendarShortKey('morning', 'امروز صبح', (now: Date) => { now.setHours(9, 0, 0, 0); }),
    next15min: new CalendarShortKey('next15min', 'یک ربع دیگه', (now: Date) => { now.setMinutes(now.getMinutes() + 15); }),
    nexthour: new CalendarShortKey('nexthour', 'یک ساعت دیگه', (now: Date) => { now.setHours(now.getHours() + 1); }),
    next2hour: new CalendarShortKey('next2hour', 'دو ساعت دیگه', (now: Date) => { now.setHours(now.getHours() + 2); }),
    next3hour: new CalendarShortKey('next3hour', 'سه ساعت دیگه', (now: Date) => { now.setHours(now.getHours() + 3); }),
    evening: new CalendarShortKey('evening', 'بعدازظهر', (now: Date) => { now.setHours(15, 0, 0, 0); now.setMinutes(0); }),
    tomorrow: new CalendarShortKey('tomorrow', 'فردا', (now: Date) => { now.setTime(now.getTime() + 1 * DateConstants.oneDay); now.setHours(8, 0, 0, 0); }),
    next2days: new CalendarShortKey('next2days', 'پس فردا', (now: Date) => { now.setTime(now.getTime() + 2 * DateConstants.oneDay); now.setHours(8, 0, 0, 0); }),
    next3days: new CalendarShortKey('next3days', 'سه روز دیگه', (now: Date) => { now.setTime(now.getTime() + 3 * DateConstants.oneDay); now.setHours(8, 0, 0, 0); }),
    next7days: new CalendarShortKey('next7days', 'هفته بعد', (now: Date) => { now.setTime(now.getTime() + 7 * DateConstants.oneDay); now.setHours(8, 0, 0, 0); }),
    tomorrowmorning: new CalendarShortKey('tomorrowmorning', 'فردا صبح', (now: Date) => { now.setTime(now.getTime() + 1 * DateConstants.oneDay); now.setHours(9, 0, 0, 0); }),
    tomorrowevening: new CalendarShortKey('tomorrowevening', ' فردا بعدازظهر', (now: Date) => { now.setTime(now.getTime() + 1 * DateConstants.oneDay); now.setHours(15, 0, 0, 0); }),
    thisweek: new CalendarShortKey('thisweek', 'پنجشنبه', (now: Date) => {
      let add = 5 - new PersianDate(now).weekday;
      if (add < 0) { add += 7; }
      now.setTime(now.getTime() + add * DateConstants.oneDay);
      now.setHours(8, 0, 0, 0);
    }),
    latethisweek: new CalendarShortKey('latethisweek', 'انتهای هفته', (now: Date) => {
      let add = 6 - new PersianDate(now).weekday;
      if (add < 0) { add += 7; }
      now.setTime(now.getTime() + add * DateConstants.oneDay);
      now.setHours(23, 59, 59);
    }),
    latenextweek: new CalendarShortKey('latenextweek', 'آخر هفته بعد', (now: Date) => {
      let add = 5 - new PersianDate(now).weekday;
      if (add < 0) { add += 7; }
      now.setTime(now.getTime() + (add + 7) * DateConstants.oneDay);
      now.setHours(8, 0, 0, 0);
    }),
    nextweek: new CalendarShortKey('nextweek', 'شنبه آینده', (now: Date) => {
      now.setTime(now.getTime() + ((7 - new PersianDate(now).weekday) || 7) * DateConstants.oneDay);
      now.setHours(8, 0, 0, 0);
    }),
    next2week: new CalendarShortKey('next2week', 'دو هفته آینده', (now: Date) => {
      now.setTime(now.getTime() + ((7 - new PersianDate(now).weekday) || 7) * DateConstants.oneDay);
      now.setTime(now.getTime() + 7 * DateConstants.oneDay);
      now.setHours(8, 0, 0, 0);
    }),
    lastweek: new CalendarShortKey('lastweek', 'یک هفته پیش', (now: Date) => { now.setTime(now.getTime() - 7 * DateConstants.oneDay); }),
    lastmonth: new CalendarShortKey('lastmonth', 'یک ماه پیش', (now: Date) => { now.setTime(now.getTime() - 30 * DateConstants.oneDay); }),
    lastyear: new CalendarShortKey('lastyear', 'یک سال پیش', (now: Date) => { now.setTime(now.getTime() - 365 * DateConstants.oneDay); }),
    mindate: new CalendarShortKey('mindate', 'همه', (now: Date) => { now.setTime(DateConstants.minDate.getTime()); }),
    nextmonth: new CalendarShortKey('nextmonth', 'ماه آینده', (now: Date) => {
      const date = new PersianDate(now).addMonth(1).toGregorian();
      now.setTime(date.getTime());
      now.setHours(8, 0, 0, 0);
    })
  };

  static DateRanges = {
    notset: new CalendarShortKey('notset', 'همه', (now: Date) => now.setTime(DateConstants.minDate.getTime()), (now: Date) => now.setTime(DateConstants.maxDate.getTime())),
    yesterday: new CalendarShortKey('yesterday', 'دیروز', (now: Date) => {
      now.setTime(now.getTime() - 1 * DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      now.setHours(0, 0, 0, 0);
    }),
    today: new CalendarShortKey('today', 'امروز', (now: Date) => now.setHours(0, 0, 0, 0), (now: Date) => {
      now.setTime(now.getTime() + 1 * DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }),
    last3hours: new CalendarShortKey('last3hours', '3 ساعت گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneHour * 3)),
    last3hours_lastweek: new CalendarShortKey('last3hours_lastweek', 'هفته پیش 3 ساعت گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek - DateConstants.oneHour * 3),
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek)
    ),
    last6hours: new CalendarShortKey('last6hours', '6 ساعت گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneHour * 6)),
    last6hours_lastweek: new CalendarShortKey('last6hours_lastweek', 'هفته پیش 6 ساعت گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek - DateConstants.oneHour * 6),
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek)
    ),
    last24hours: new CalendarShortKey('last24hours', '24 ساعت گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneDay)),
    last24hours_lastweek: new CalendarShortKey('last24hours_lastweek', 'هفته پیش 24 ساعت گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek - DateConstants.oneDay),
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek)
    ),
    last7days: new CalendarShortKey('last7days', '7 روز گذشته',
      (now: Date) => {
        now.setTime(now.getTime() - DateConstants.oneWeek);
        now.setHours(0, 0, 0, 0);
      },
      (now: Date) => {
        now.setTime(now.getTime() + DateConstants.oneDay);
        now.setHours(0, 0, 0, 0);
      },
    ),
    last7daystonow: new CalendarShortKey('last7daystonow', '7 روز گذشته', (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek)),
    last14to7days: new CalendarShortKey('last14to7days', '14 تا 7 روز گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek * 2),
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek)
    ),
    last4weeks: new CalendarShortKey('last4weeks', '4 هفته گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek * 4)
    ),
    last8to4weeks: new CalendarShortKey('last8to4weeks', '8 تا 4 هفته گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek * 8),
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneWeek * 4)
    ),
    tomorrow: new CalendarShortKey('tomorrow', 'فردا', (now: Date) => {
      now.setTime(now.getTime() + 1 * DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      now.setTime(now.getTime() + 2 * DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }),
    thisweek: new CalendarShortKey('thisweek', 'هفته جاری', (now: Date) => {
      now.setTime(now.getTime() - new PersianDate(now).weekday * DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      now.setTime(now.getTime() - new PersianDate(now).weekday * DateConstants.oneDay + 7 * DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }),
    nextweek: new CalendarShortKey('nextweek', 'هفته بعد', (now: Date) => {
      now.setTime(now.getTime() - new PersianDate(now).weekday * DateConstants.oneDay + 7 * DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      now.setTime(now.getTime() - new PersianDate(now).weekday * DateConstants.oneDay + 15 * DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }),
    thismonth: new CalendarShortKey('thismonth', 'ماه جاری', (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.day = 1;
      now.setTime(persianDate.toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.day = 1;
      now.setTime(persianDate.addMonth(1).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }),
    lastmonth: new CalendarShortKey('lastmonth', 'ماه قبل', (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.day = 1;
      now.setTime(persianDate.addMonth(-1).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.day = 1;
      now.setTime(persianDate.toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }),
    last3month: new CalendarShortKey('last3month', '3 ماه گذشته', (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.day = 1;
      now.setTime(persianDate.addMonth(-3).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      now.setHours(0, 0, 0, 0);
    }),
    last12month: new CalendarShortKey('last12month', '12 ماه گذشته', (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.day = 1;
      now.setTime(persianDate.addMonth(-12).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      now.setHours(0, 0, 0, 0);
    }),
    thisyear: new CalendarShortKey('thisyear', 'سال جاری', (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.month = 1;
      persianDate.day = 1;
      now.setTime(persianDate.toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.month = 1;
      persianDate.day = 1;
      now.setTime(persianDate.addMonth(12).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
      now.setTime(now.getTime() - 1);
    }),
    lastyear: new CalendarShortKey('lastyear', 'سال پیش', (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.month = 1;
      persianDate.day = 1;
      persianDate.year--;
      now.setTime(persianDate.toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      const persianDate = new PersianDate(now);
      persianDate.month = 1;
      persianDate.day = 1;
      now.setTime(persianDate.toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }),
    last30days: new CalendarShortKey('last30days', '30 روز گذشته', (now: Date) => {
      const persianDate = new PersianDate(now);
      now.setTime(persianDate.addDay(-30).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      now.setTime(now.getTime() + DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }),
    last30daystonow: new CalendarShortKey('last30daystonow', '30 روز گذشته', (now: Date) => now.setTime(now.getTime() - DateConstants.oneMonth)),
    last60to30days: new CalendarShortKey('last60to30days', '60 تا 30 روز گذشته',
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneMonth * 2),
      (now: Date) => now.setTime(now.getTime() - DateConstants.oneMonth)
    ),
    last90days: new CalendarShortKey('last90days', '90 روز گذشته', (now: Date) => {
      const persianDate = new PersianDate(now);
      now.setTime(persianDate.addDay(-90).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }, (now: Date) => {
      now.setTime(now.getTime() + DateConstants.oneDay);
      now.setHours(0, 0, 0, 0);
    }),
    last180days: new CalendarShortKey('last180days', '6 ماه گذشته', (now: Date) => {
      const persianDate = new PersianDate(now);
      now.setTime(persianDate.addDay(-180).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }),
    last365days: new CalendarShortKey('last365days', '1 سال گذشته', (now: Date) => {
      const persianDate = new PersianDate(now);
      now.setTime(persianDate.addDay(-365).toGregorian().getTime());
      now.setHours(0, 0, 0, 0);
    }),
  };

  static DayTimeShortkeys: { [key: string]: DayTimeShortKey } = {
    morning: new DayTimeShortKey('morning', 'صبح', 7),
    work_start: new DayTimeShortKey('work_start', 'اول وقت کاری', 8),
    noon: new DayTimeShortKey('noon', 'ظهر', 12),
    work_end: new DayTimeShortKey('work_end', 'آخر وقت کاری', 17),
    evening: new DayTimeShortKey('evening', 'شب', 21)
  };

  private static GREGORIAN_EPOCH = 1721425.5;
  private static Hijri_EPOCH = 1948084;

  onchanged?: () => void;

  private _year: number = 0;
  private _month: number = 0;
  private _day: number = 0;
  private _hour: number = 0;
  private _minute: number = 0;

  private _weekday?: number;
  static isHoliday(date: Date) { return new PersianDate(date).isHoliday(); }

  static diff(part: 'DAY' | 'MONTH' | 'YEAR', from?: Date, to = new Date()) {
    if (!from) return null;
    var _from = new PersianDate(from);
    var _to = new PersianDate(to);
    switch (part) {
      case 'DAY':
        return (to.getTime() - from.getTime()) / DateConstants.oneDay;
      case 'MONTH':
        return (_to.year - _from.year) * 12 + (_to.month - _from.month);
      case 'YEAR':
        return Math.floor((_to.year - _from.year) * 12 + (_to.month - _from.month)) / 12;
    }
  }

  static relative(date: Date | number, showTime = true, showOldDate = true, isTimespan = false, exactTime = false) {
    let minutes: number;
    let _date: Date;
    if (date instanceof Date) {
      const now = new Date();
      if (now.getFullYear() - date.getFullYear() > 5) { return new PersianDate(date).toString(showTime ? DateFormat.LongDateTime : DateFormat.LongDate); }
      minutes = (date.getTime() - now.getTime()) / (60000);
      _date = new Date(date.getTime());
    } else {
      minutes = date;
      _date = new Date(Date.now() + minutes * 60000);
    }
    const pdate = new PersianDate(_date);

    const past = (minutes < 0);
    minutes = Math.round(Math.abs(minutes));
    if (minutes < 1) { return isTimespan ? '0 دقیقه' : date instanceof Date ? 'همین الان' : 'در لحظه'; }

    let result = '';
    // if (minutes < 60)
    //  result = minutes + ' دقیقه';
    // else if (minutes < (24 * 60))
    //  result = Math.round(minutes / 60) + ' ساعت';
    // else if (minutes < (30 * 24 * 60))
    //  result = Math.round(minutes / (24 * 60)) + ' روز';
    // else if (!showOldDate || !(date instanceof Date)) {
    //  if (minutes < (365 * 24 * 60))
    //    result = Math.round(minutes / (30 * 24 * 60)) + ' ماه';
    //  else
    //    result = Math.round(minutes / (365 * 24 * 60)) + ' سال';
    // }
    // else
    //  return new PersianDate(date).toString(showTime ? DateFormat.LongDate : DateFormat.LongDateTime);

    const copy = new Date(_date.getTime());
    if (minutes < 60) {
      result = exactTime ? minutes + ' دقیقه' : 'چند لحظه';
    } else if (minutes < (24 * 60)) {
      result = exactTime ? Math.round(minutes / 60) + ' ساعت' : 'چند ساعت';
    } else if (minutes < (7 * 24 * 60)) {
      result = Math.round(minutes / (24 * 60)) + ' روز';
    } else if (minutes < (30 * 24 * 60)) {
      result = Math.round(minutes / (7 * 24 * 60)) + ' هفته';
    } else if (!showOldDate || !(date instanceof Date)) {
      if (pdate.year == new PersianDate().year) {
        return ('0' + pdate.day).slice(-2) + ' ' + PersianDate.MonthNames[pdate.month] + ' امسال';
      } else if (minutes < (365 * 24 * 60)) {
        result = Math.round(minutes / (30 * 24 * 60)) + ' ماه';
      } else {
        result = Math.round(minutes / (365 * 24 * 60)) + ' سال';
      }
    } else {
      return pdate.toString(showTime ? DateFormat.LongDate : DateFormat.LongDateTime);
    }

    if (!isTimespan) {
      result += ' ' + (date instanceof Date ? (past ? 'پیش' : 'مانده') : (past ? 'قبل' : 'بعد'));
    }
    return result;
  }
  static RecurrenceName(type: RecurrenceType | string): { type: RecurrenceType, title: string } {
    return PersianDate.RecurrenceNames.find(_ => _.type == type || RecurrenceType[_.type] == type) || PersianDate.RecurrenceNames[0];
  }

  private static mod(a: number, b: number) {
    return a - (b * Math.floor(a / b));
  }

  private static julianToWeekday(j: number) {
    return PersianDate.mod(Math.floor((j + 1.5)), 7);
  }

  private static gregorianIsLeap(year: number) {
    return ((year % 4) == 0) && (!(((year % 100) == 0) && ((year % 400) != 0)));
  }

  private static gregorianToJulianDay(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return (PersianDate.GREGORIAN_EPOCH - 1) +
      (365 * (year - 1)) +
      Math.floor((year - 1) / 4) +
      (-Math.floor((year - 1) / 100)) +
      Math.floor((year - 1) / 400) +
      Math.floor((((367 * month) - 362) / 12) + ((month <= 2) ? 0 : (PersianDate.gregorianIsLeap(year) ? -1 : -2)) +
        day);
  }
  private static persianToJulianDay(persianDate: PersianDate) {
    const epbase = persianDate.year - ((persianDate.year >= 0) ? 474 : 473);
    const epyear = 474 + (epbase % 2820);
    return persianDate.day + ((persianDate.month <= 7) ? ((persianDate.month - 1) * 31) : (((persianDate.month - 1) * 30) + 6)) + Math.floor(((epyear * 682) - 110) / 2816) + (epyear - 1) * 365 + Math.floor(epbase / 2820) * 1029983 + (1948320.5 - 1);
  }
  private static julianDayToPersian(jd: number) {
    let year: number, month: number, day: number, depoch: number, cycle: number,
      cyear: number, ycycle: number, aux1: number, aux2: number, yday: number;

    jd = Math.floor(jd) + 0.5;
    depoch = jd - PersianDate.persianToJulianDay(new PersianDate(475, 1, 1));
    cycle = Math.floor(depoch / 1029983);
    cyear = PersianDate.mod(depoch, 1029983);
    if (cyear == 1029982) {
      ycycle = 2820;
    } else {
      aux1 = Math.floor(cyear / 366);
      aux2 = PersianDate.mod(cyear, 366);
      ycycle = Math.floor(((2134 * aux1) + (2816 * aux2) + 2815) / 1028522) + aux1 + 1;
    }
    year = ycycle + (2820 * cycle) + 474;
    if (year <= 0) {
      year--;
    }
    yday = (jd - PersianDate.persianToJulianDay(new PersianDate(year, 1, 1))) + 1;
    month = (yday <= 186) ? Math.ceil(yday / 31) : Math.ceil((yday - 6) / 30);
    day = (jd - PersianDate.persianToJulianDay(new PersianDate(year, month, 1))) + 1;
    return new PersianDate(year, month, day);
  }
  private static julianDayToGregorian(jd: number) {
    let wjd: number, depoch: number, quadricent: number, dqc: number,
      cent: number, dcent: number, quad: number, dquad: number, yindex: number,
      year: number, yearday: number, leapadj: number;

    wjd = Math.floor(jd - 0.5) + 0.5;
    depoch = wjd - PersianDate.GREGORIAN_EPOCH;
    quadricent = Math.floor(depoch / 146097);
    dqc = PersianDate.mod(depoch, 146097);
    cent = Math.floor(dqc / 36524);
    dcent = PersianDate.mod(dqc, 36524);
    quad = Math.floor(dcent / 1461);
    dquad = PersianDate.mod(dcent, 1461);
    yindex = Math.floor(dquad / 365);
    year = (quadricent * 400) + (cent * 100) + (quad * 4) + yindex;
    if (!((cent == 4) || (yindex == 4))) {
      year++;
    }
    const yearDate = new Date();
    yearDate.setFullYear(year);
    yearDate.setMonth(0);
    yearDate.setDate(1);
    yearday = wjd - PersianDate.gregorianToJulianDay(yearDate);
    yearDate.setMonth(2);
    leapadj = ((wjd < PersianDate.gregorianToJulianDay(yearDate)) ? 0 : (PersianDate.gregorianIsLeap(year) ? 1 : 2));
    const month = Math.floor((((yearday + leapadj) * 12) + 373) / 367);
    yearDate.setMonth(month - 1);
    const day = (wjd - PersianDate.gregorianToJulianDay(yearDate)) + 1;
    const t = new Date(year + '/' + month + '/' + day);
    return t;
  }
  private static julianDayToHijri(jd: number, adjust = 1.1) {
    const iyear = 10631. / 30.;
    const shift1 = 8.01 / 60.;

    let z = jd - PersianDate.Hijri_EPOCH + adjust;
    const cyc = Math.floor(z / 10631.);
    z = z - 10631 * cyc;
    const j = Math.floor((z - shift1) / iyear);
    const iy = 30 * cyc + j;
    z = z - Math.floor(j * iyear + shift1);
    let im = Math.floor((z + 28.5001) / 29.5);
    if (im == 13) { im = 12; }
    const id = Math.floor(z - (29.5001 * im - 29));

    return new HijriDate(iy, im, id || 1);
  }
  private static splitDateString(dateString: string) {
    let dArray: string[];
    if (dateString.indexOf('/') >= 0) {
      dArray = dateString.split('/');
    } else if (dateString.indexOf('.') >= 0) {
      dArray = dateString.split('.');
    } else if (dateString.indexOf('-') >= 0) {
      dArray = dateString.split('-');
    } else if (dateString.indexOf('\\') >= 0) {
      dArray = dateString.split('\\');
    } else {
      dArray = [];
    }

    return dArray;
  }
  static isLeap(year: number) {
    return ((((((year - ((year > 0) ? 474 : 473)) % 2820) + 474) + 38) * 682) % 2816) < 682;
  }

  static formatRepeatPattern(type: RecurrenceType, repeatEvery: number = 0, days: string[] = [], startDate: string = '', toDate: string = '') {
    let repeatEveryStr = (repeatEvery > 1) ? 'هر ' + repeatEvery + ' ' : 'هر ';
    switch (type) {
      case RecurrenceType.Daily:
        repeatEveryStr += 'روز';
        break;
      case RecurrenceType.Weekly:
        repeatEveryStr += 'هفته';
        break;
      case RecurrenceType.Monthly:
        repeatEveryStr += 'ماه';
        break;
      case RecurrenceType.BiMonthly:
        repeatEveryStr += 'دو ماه';
        break;
      case RecurrenceType.TriMonthly:
        repeatEveryStr += 'سه ماه';
        break;
      case RecurrenceType.HalfYearly:
        repeatEveryStr += 'شش ماه';
        break;
      case RecurrenceType.Yearly:
        repeatEveryStr += 'سال';
        break;
      default:
      case RecurrenceType.None:
        return 'فقط یک بار';
    }

    const daysStr = '';
    if (type != RecurrenceType.Daily && days.length > 0) {
      let daysStr = (days.length > 1) ? 'روزهای ' : 'روز ';
      for (let i = 0; i < days.length; i++) {
        if (type == RecurrenceType.Weekly) {
          daysStr += PersianDate.Weekdays[+days[i]] + '، ';
        } else {
          daysStr += days[i] + '، ';
        }
      }
      daysStr = daysStr.replace(/، $/, '');
    }
    const start = !!startDate ? ' از تاریخ ' + startDate : '';
    const end = !!toDate ? ' تا تاریخ ' + toDate : '';

    return repeatEveryStr + ' ' + daysStr + start + end;
  }

  setTime(hour: number = 0, minute: number = 0) {
    this.hour = hour;
    this.minute = minute;
    return this;
  }

  private _onchanged() {
    if (this.onchanged) { this.onchanged(); }
  }

  isEqual(date: PersianDate | Date, checkTime: boolean = true) {
    const _date: PersianDate = date instanceof Date ? new PersianDate(date) : date;
    if (this.year !== _date.year || this.month !== _date.month || this.day !== _date.day) { return false; }
    if (checkTime && (this.hour !== _date.hour || this.minute !== _date.minute)) { return false; }
    return true;
  }

  isHoliday() {
    if (DateConstants.persianHolidays[this.month + '-' + this.day]) { return true; }
    if (DateConstants.persianIslamicHolidays[this.year]) {
      return !!DateConstants.persianIslamicHolidays[this.year][this.month + '-' + this.day];
    } else {
      const h = this.toHijriDate();
      return !!DateConstants.islamicHolidays[h.month + '-' + h.day];
    }
  }

  occasion() {
    const h = this.toHijriDate();
    // var g = this.toGregorian();

    return [
      ...(DateConstants.persianHolidays[this.month + '-' + this.day] || []),
      ...((DateConstants.persianIslamicHolidays[this.year] ?
        DateConstants.persianIslamicHolidays[this.year][this.month + '-' + this.day] :
        DateConstants.islamicHolidays[h.month + '-' + h.day]) || []),
      // ...(DateConstants.persianDays[this.month + '-' + this.day] || []),
      // ...(DateConstants.islamicDays[h.month + '-' + h.day] || []),
      // ...(DateConstants.worldDays[g.getMonth() + '-' + g.getDay()] || [])
    ].filter(_ => !!_).join('\n');
    // return {
    //  persianHolidays: DateConstants.persianHolidays[this.month + '-' + this.day],
    //  islamicHolidays: DateConstants.islamicHolidays[h.month + '-' + h.day],
    //  persianDays: DateConstants.persianDays[this.month + '-' + this.day],
    //  islamicDays: DateConstants.islamicDays[h.month + '-' + h.day],
    //  worldDays: DateConstants.worldDays[g.getMonth() + '-' + g.getDay()]
    // };
  }

  static toString(date: Date, format?: string | DateFormat | boolean) {
    return new PersianDate(date).toString(format || DateFormat.ShortDate);
  }
  toString(format?: string | DateFormat | boolean) {
    if (this.isNaN() ||
      this.toGregorian().getTime() <= DateConstants.minDate.getTime() ||
      this.toGregorian().getTime() >= DateConstants.maxDate.getTime()) {
      return 'نامشخص';
    }

    if (format == undefined || format === false) {
      format = (format !== false && (this.hour || this.minute) ? DateFormat.LongDateTime : DateFormat.LongDate);
    }

    let _format: string;
    if (typeof format != 'string') {
      switch (<DateFormat>format) {
        default:
        case DateFormat.LongDate:
          _format = '[W] [d] [M] [yyyy]';
          break;
        case DateFormat.LongDateTime:
          _format = '[W] [d] [M] [yyyy]، ساعت [h]:[mi]';
          break;
        case DateFormat.ShortDate:
          _format = '[yy]/[mm]/[dd]';
          break;
        case DateFormat.ShortDateTime:
          _format = '[yy]/[mm]/[dd] [h]:[mi]';
          break;
        case DateFormat.TodayTime:
          var diff = Math.abs(Date.now() - this.toGregorian().getTime());
          if (diff < DateConstants.oneDay) _format = '[h]:[mi]';
          else if (diff < DateConstants.oneWeek) _format = '[W]';
          else _format = '[yy]/[m]/[d]';
          break;
      }
    } else { _format = <string>format; }

    // if (format == '[R]')
    //  return this.lc_relative();
    // if (format == '[RT]')
    //  return this.lc_relative(true);

    if (this.year >= 1400)
      _format = _format.replace('[yy]', '[yyyy]');

    _format = _format.replace('[yyyy]', this.year.toString());
    _format = _format.replace('[yy]', (this.year % 100).toString());
    _format = _format.replace('[m]', this.month.toString());
    _format = _format.replace('[mm]', ('0' + this.month).slice(-2));
    _format = _format.replace('[M]', PersianDate.MonthNames[this.month]);
    _format = _format.replace('[d]', this.day.toString());
    _format = _format.replace('[dd]', ('0' + this.day).slice(-2));
    _format = _format.replace('[w]', PersianDate.WeekdaysShort[this.weekday]);
    _format = _format.replace('[W]', PersianDate.Weekdays[this.weekday]);
    _format = _format.replace('[wn]', this.week.toString());
    _format = _format.replace('[wN]', PersianDate.OrdinalNumbers[this.week]);
    _format = _format.replace('[h]', ('0' + this.hour).slice(-2));
    _format = _format.replace('[mi]', ('0' + this.minute).slice(-2));
    _format = _format.replace('[hh]', ('0' + this.hour).slice(-2));
    _format = _format.replace('[MM]', ('0' + this.minute).slice(-2));

    return _format;
  }

  addDay(day: number, miliseconds = 0) {
    const date = this.toGregorian();
    date.setTime(date.getTime() + day * DateConstants.oneDay + miliseconds);
    return new PersianDate(date);
  }

  addMonth(month: number) {
    const date = new PersianDate(this.toGregorian());
    month = date.month + month;
    date.month = ((month % 12 + 12) % 12) || 12;
    date.year += Math.floor((month - 1) / 12);

    if (date.day > 29) {
      if (date.month == 12) { date.day = date.isLeap ? 30 : 29; } else if (date.month > 6) { this.day = 30; }
    }
    return date;
  }

  toHijriDate() {
    const j = PersianDate.persianToJulianDay(this);
    return PersianDate.julianDayToHijri(j);
  }
  isNaN() {
    if (!this.year)
      return true;
    return isNaN(this.toGregorian().getTime());
  }
  toGregorian() {
    const j = PersianDate.persianToJulianDay(this);
    const result = PersianDate.julianDayToGregorian(j);
    result.setHours(this.hour || 0);
    result.setMinutes(this.minute || 0);
    return result;
  }
}
